import EmployeeSettingsPage from "./EmployeeSettingsPage";

export default EmployeeSettingsPage;
